<template lang="html">
  <div class="master-input-date row">
  	<custom-select v-model="day" :items="days" :solo="true"/>
  	<custom-select v-model="month" :items="months" :solo="true"/>
  	<custom-select v-model="year" :items="years" :solo="true"/>
  </div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'

export default {
	name: 'input-date',
	props: ['value'],
	components: {
		CustomSelect
	},
	data () {
		return {
			day: 0,
			days: Array.from(Array(31), (d, i) => i + 1),
			month: null,
			months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			year: null,
			years: [],
			dayForMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
		}
	},
	mounted () {
		this.years = Array.from(Array(this.value.getFullYear() - 1999), (d, i) => 2000 + i).reverse()
		this.year = this.value.getFullYear()
		this.day = this.value.getDate()
		this.month = this.months[this.value.getMonth()]
	},
	methods: {
		setDays () {
			const key = this.months.indexOf(this.month)
			let nbOfDay = this.dayForMonth[key]
			if (key === 1) {
				const year = this.year
				let common = true
				if (year % 4 === 0) {
					common = false
					if (year % 100 === 0) {
						common = true
						if (year % 400 === 0) {
							common = false
						}
					}
				}

				nbOfDay = (common) ? 28 : 29
			}

			this.days = Array.from(Array(nbOfDay), (d, i) => i + 1)
			if (this.days.indexOf(this.day) === -1) this.day = this.days[this.days.length - 1]

			let month = this.months.indexOf(this.month) + 1

			if (month < 10) {
				month = '0' + month
			}

			let date = this.$moment(`${this.day}/${month}/${this.year}`, 'DD/MM/YYYY').toDate()

			this.$emit('change', date)
			this.$emit('input', date)
		}
	},
	watch: {
		month () { this.setDays() },
		year () { this.setDays() },
		day () { this.setDays() }
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// InputDate.vue?69bfcfc8